import { useCheckInAndCheckOut } from "@/components/features/_hooks/use-check-in-and-check-out/use-check-in-and-check-out";
import { useAccommodationHotelPolicyFormModelContext } from "@/components/features/items/edit/hotel-policy/default/ui/context";

export const useCheckInAndCheckOutOfHotelPolicy = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { checkInStart, checkInEnd, checkOut } = viewModel;

	return useCheckInAndCheckOut({
		checkInStart,
		checkInEnd,
		checkOut,
		onSetViewModel,
	});
};
